module.exports = __webpack_public_path__ + "img/mogujie.e88915e5.png";